﻿window.HcProductGallery = window.HcProductGallery || {};

window.HcProductGallery.init = (section) => {
  if (!section || section.dataset.hcGalleryReady === 'true') return;
  section.dataset.hcGalleryReady = 'true';

      const mainSliderNode = section.querySelector('[data-hc-main-slider]');
      const thumbSliderNode = section.querySelector('[data-hc-thumb-slider]');
      const thumbContainer = section.querySelector('.hc-product__thumbnails-container');
      const mainSlides = Array.from(section.querySelectorAll('.hc-product__main-slide'));
      const galleryPrev = section.querySelector('[data-hc-gallery-prev]');
      const galleryNext = section.querySelector('[data-hc-gallery-next]');
      let emblaApi = null;
      let thumbEmblaApi = null;
      let currentThumbAxis = null;
      let currentActiveMediaIndex = -1;
      const shouldUseThumbEmbla = () => window.matchMedia('(min-width: 1200px) and (hover: hover) and (pointer: fine)').matches;
      const shouldUseMainEmbla = () => Boolean(section.closest('quick-add-modal')) || shouldUseThumbEmbla();

      const isQuickGallery = Boolean(section.closest('quick-add-modal'));
      const thumbnailButtons = Array.from(section.querySelectorAll('.hc-product__thumb-btn[data-slide-index]'));
      const thumbnailsMore = section.querySelector('[data-hc-thumbnails-more]');
      let thumbnailsExpanded = false;
      const hydrateMainImage = (index) => {
        const image = mainSlides[index]?.querySelector('[data-hc-gallery-image]');
        if (!image || image.dataset.hcLoaded === 'true') return;

        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src) image.src = image.dataset.src;
        image.dataset.hcLoaded = 'true';
        delete image.dataset.src;
        delete image.dataset.srcset;
      };
      const requestMainImage = (index, priority = 'low', decode = false) => {
        hydrateMainImage(index);
        const image = mainSlides[index]?.querySelector('[data-hc-gallery-image]');
        if (!image) return;

        image.loading = 'eager';
        image.fetchPriority = priority;
        if (decode && typeof image.decode === 'function') {
          image.decode().catch(() => undefined);
        }
      };
      const warmMainImages = () => {
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;

        mainSlides.forEach((slide, index) => {
          if (index > 2) requestMainImage(index);
        });
      };
      const fitQuickThumbnails = () => {
        if (!isQuickGallery || !thumbSliderNode || !thumbContainer || !thumbnailButtons.length) return;
        const availableWidth = thumbSliderNode.clientWidth;
        const buttonWidth = thumbnailButtons[0].getBoundingClientRect().width;
        if (!availableWidth || !buttonWidth) return;
        const gap = parseFloat(getComputedStyle(thumbContainer).columnGap) || 0;
        const capacity = Math.max(1, Math.floor((availableWidth + gap) / (buttonWidth + gap)));
        const visibleCount = thumbnailsExpanded || thumbnailButtons.length <= capacity || !thumbnailsMore
          ? thumbnailButtons.length : Math.max(1, capacity - 1);
        thumbnailButtons.forEach((button, index) => {
          button.hidden = index >= visibleCount;
          button.classList.toggle('is-hidden-extra', button.hidden);
        });
        if (thumbnailsMore) {
          thumbnailsMore.hidden = visibleCount >= thumbnailButtons.length;
          thumbnailsMore.textContent = `+${thumbnailButtons.length - visibleCount}`;
        }
        thumbEmblaApi?.reInit();
      };
      if (isQuickGallery && thumbSliderNode) {
        const thumbnailResizeObserver = new ResizeObserver(() => {
          if (!section.isConnected) {
            thumbnailResizeObserver.disconnect();
            return;
          }
          fitQuickThumbnails();
        });
        thumbnailResizeObserver.observe(thumbSliderNode);
        thumbnailResizeObserver.observe(thumbnailButtons[0]);
      }

      const initThumbEmbla = () => {
        if (!window.EmblaCarousel || !thumbSliderNode || !thumbContainer) return;
        if (!shouldUseThumbEmbla()) {
          if (thumbEmblaApi) {
            thumbEmblaApi.destroy();
            thumbEmblaApi = null;
          }
          currentThumbAxis = null;
          return;
        }

        const isVertical = window.getComputedStyle(thumbContainer).flexDirection === 'column';
        const newAxis = isVertical ? 'y' : 'x';
        
        if (currentThumbAxis !== newAxis) {
          if (thumbEmblaApi) thumbEmblaApi.destroy();
          thumbEmblaApi = window.EmblaCarousel(thumbSliderNode, {
            axis: newAxis,
            containScroll: 'keepSnaps',
            dragFree: true
          });
          currentThumbAxis = newAxis;
        }
      };

      const updateThumbnails = (index, options = {}) => {
        currentActiveMediaIndex = index;
        requestMainImage(index, 'high', true);
        requestMainImage(index - 1);
        requestMainImage(index + 1);

        const shouldKeepThumbPosition = options.keepThumbPosition === true;
        let activeButton = null;
        section.querySelectorAll('.hc-product__thumb-btn').forEach((button) => {
          const isActive = Number(button.dataset.slideIndex) === index;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-pressed', String(isActive));
          if (isActive) activeButton = button;
        });
        if (thumbEmblaApi) {
          thumbEmblaApi.scrollTo(index);
        } else if (activeButton && !shouldKeepThumbPosition) {
          activeButton.scrollIntoView({
            block: 'nearest',
            inline: 'nearest',
            behavior: 'auto'
          });
        }

        if (galleryPrev) galleryPrev.disabled = index <= 0;
        if (galleryNext) galleryNext.disabled = index >= mainSlides.length - 1;
      };

      let mainNavigationTargetIndex = null;
      const goToMainIndex = (index, behavior = 'smooth') => {
        const nextIndex = Math.min(Math.max(Number(index) || 0, 0), Math.max(mainSlides.length - 1, 0));
        if (emblaApi) {
          emblaApi.scrollTo(nextIndex, behavior === 'auto');
        } else if (mainSliderNode) {
          const targetLeft = nextIndex * mainSliderNode.offsetWidth;
          mainNavigationTargetIndex = behavior === 'auto' && Math.abs(mainSliderNode.scrollLeft - targetLeft) > 1
            ? nextIndex
            : null;
          mainSliderNode.scrollTo({ left: targetLeft, behavior });
        }
        updateThumbnails(nextIndex, { keepThumbPosition: behavior === 'auto' });
      };

      const initMainEmbla = () => {
        if (!mainSliderNode) return;
        if (!shouldUseMainEmbla()) {
          if (emblaApi) {
            emblaApi.destroy();
            emblaApi = null;
            mainSliderNode.classList.remove('is-embla-ready', 'is-dragging');
          }
          return;
        }
        if (emblaApi || !window.EmblaCarousel) return;

        mainSliderNode.scrollLeft = 0;

        emblaApi = window.EmblaCarousel(mainSliderNode, {
          container: '.hc-product__main-track',
          align: 'start',
          loop: false,
          dragFree: false,
          containScroll: 'trimSnaps',
          duration: 12
        });

        mainSliderNode.classList.add('is-embla-ready');
        emblaApi
          .on('select', () => updateThumbnails(emblaApi.selectedScrollSnap()))
          .on('settle', () => {
            updateThumbnails(emblaApi.selectedScrollSnap());
          })
          .on('pointerDown', () => {
            mainSliderNode.classList.add('is-dragging');
          })
          .on('pointerUp', () => {
            mainSliderNode.classList.remove('is-dragging');
          });
      };

      const initGallerySliders = () => {
        fitQuickThumbnails();
        initMainEmbla();
        initThumbEmbla();
      };
      if (isQuickGallery) section.hcRefreshGallery = initGallerySliders;

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGallerySliders, { once: true });
      } else {
        initGallerySliders();
      }

      window.addEventListener('load', initGallerySliders, { once: true });

      let galleryResizeFrame = null;
      window.addEventListener('resize', () => {
        if (galleryResizeFrame) return;
        galleryResizeFrame = window.requestAnimationFrame(() => {
          galleryResizeFrame = null;
          initGallerySliders();
        });
      });

      let nativeScrollFrame = null;
      mainSliderNode?.addEventListener('scroll', () => {
        if (emblaApi || nativeScrollFrame) return;

        nativeScrollFrame = window.requestAnimationFrame(() => {
          nativeScrollFrame = null;
          const slideWidth = mainSliderNode.offsetWidth || 1;
          const index = Math.round(mainSliderNode.scrollLeft / slideWidth);

          if (mainNavigationTargetIndex !== null) {
            const targetIndex = mainNavigationTargetIndex;
            const hasReachedTarget = Math.abs(mainSliderNode.scrollLeft - targetIndex * slideWidth) <= 1;
            if (hasReachedTarget) {
              mainNavigationTargetIndex = null;
              updateThumbnails(targetIndex);
            }
            return;
          }

          updateThumbnails(index);
        });
      }, { passive: true });

      section.addEventListener('click', (event) => {
        const moreButton = event.target.closest('[data-hc-thumbnails-more]');
        if (moreButton && section.contains(moreButton)) {
          thumbnailsExpanded = true;
          section.querySelectorAll('.hc-product__thumb-btn.is-hidden-extra').forEach((button) => {
            button.hidden = false;
            button.classList.remove('is-hidden-extra');
          });
          moreButton.setAttribute('aria-expanded', 'true');
          moreButton.hidden = true;
          thumbEmblaApi?.reInit();
          return;
        }

        const thumbnail = event.target.closest('.hc-product__thumb-btn[data-slide-index]');
        if (!thumbnail || !section.contains(thumbnail)) return;
        const index = Number(thumbnail.dataset.slideIndex);
        requestMainImage(index, 'high', true);
        goToMainIndex(index, 'auto');
      });

      const prepareThumbnailImage = (event) => {
        const thumbnail = event.target.closest?.('.hc-product__thumb-btn[data-slide-index]');
        if (!thumbnail || !section.contains(thumbnail)) return;
        requestMainImage(Number(thumbnail.dataset.slideIndex), 'high', true);
      };
      section.addEventListener('pointerover', prepareThumbnailImage, { passive: true });
      section.addEventListener('pointerdown', prepareThumbnailImage, { passive: true });
      section.addEventListener('focusin', prepareThumbnailImage);

      galleryPrev?.addEventListener('click', (event) => {
        event.stopPropagation();
        goToMainIndex(currentActiveMediaIndex - 1);
      });
      galleryNext?.addEventListener('click', (event) => {
        event.stopPropagation();
        goToMainIndex(currentActiveMediaIndex + 1);
      });

      section.addEventListener('hc:variant-change', (event) => {
        const mediaId = event.detail?.variant?.featured_media?.id || event.detail?.variant?.featured_image?.id;
        if (!mediaId) return;
        const mediaIndex = mainSlides.findIndex((slide) => String(slide.dataset.mediaId) === String(mediaId));
        if (mediaIndex >= 0) goToMainIndex(mediaIndex, 'auto');
      });

      updateThumbnails(0, { keepThumbPosition: true });

      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(warmMainImages, { timeout: 1200 });
      } else {
        window.setTimeout(warmMainImages, 600);
      }

      const lightbox = section.querySelector('[data-hc-product-lightbox]');
      const lightboxSlider = section.querySelector('[data-hc-lightbox-slider]');
      const lightboxSlides = Array.from(section.querySelectorAll('[data-hc-lightbox-slide]'));
      const lightboxThumbs = Array.from(section.querySelectorAll('[data-hc-lightbox-thumb]'));
      const lightboxPrev = section.querySelector('[data-hc-lightbox-prev]');
      const lightboxNext = section.querySelector('[data-hc-lightbox-next]');
      const lightboxCloseControls = section.querySelectorAll('[data-hc-lightbox-close]');
      let lightboxIndex = 0;
      let lightboxScrollFrame = null;
      let lightboxSnapTimer = null;
      let lightboxPreviousBodyOverflow = '';
      let lightboxPreviousFocus = null;
      let lightboxPointerStart = null;
      let lightboxPointerIsDown = false;
      let mainPointerStart = null;
      let mainPointerDragged = false;
      let mainSuppressClickUntil = 0;

      const clampLightboxIndex = (index) => {
        const maxIndex = Math.max(lightboxSlides.length - 1, 0);
        return Math.min(maxIndex, Math.max(0, Number.isFinite(index) ? index : 0));
      };

      const getCurrentGalleryIndex = () => {
        if (emblaApi) return emblaApi.selectedScrollSnap();

        if (mainSliderNode?.offsetWidth) {
          return clampLightboxIndex(Math.round(mainSliderNode.scrollLeft / mainSliderNode.offsetWidth));
        }

        const activeThumb = section.querySelector('.hc-product__thumb-btn.is-active');
        return clampLightboxIndex(Number(activeThumb?.dataset.slideIndex) || 0);
      };

      const updateLightboxControls = (index) => {
        lightboxIndex = clampLightboxIndex(index);

        lightboxThumbs.forEach((thumb) => {
          const isActive = Number(thumb.dataset.hcLightboxThumb) === lightboxIndex;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-pressed', String(isActive));
        });

        if (lightboxPrev) lightboxPrev.disabled = lightboxIndex <= 0;
        if (lightboxNext) lightboxNext.disabled = lightboxIndex >= lightboxSlides.length - 1;
      };

      const setLightboxIndex = (index, behavior = 'smooth') => {
        if (!lightboxSlider) return;

        const nextIndex = clampLightboxIndex(index);
        hydrateLightboxImages(nextIndex);
        updateLightboxControls(nextIndex);
        lightboxSlider.scrollTo({
          left: nextIndex * lightboxSlider.offsetWidth,
          behavior
        });
      };

      const hydrateLightboxImages = (index = lightboxIndex) => {
        const nearbyIndexes = [index - 1, index, index + 1]
          .map(clampLightboxIndex)
          .filter((value, itemIndex, values) => values.indexOf(value) === itemIndex);

        nearbyIndexes.forEach((nearbyIndex) => {
          const image = lightboxSlides[nearbyIndex]?.querySelector('[data-hc-lightbox-image]');
          if (!image) return;
          if (image.dataset.hcLoaded === 'true') return;

          if (image.dataset.srcset) image.srcset = image.dataset.srcset;
          if (image.dataset.src) image.src = image.dataset.src;
          image.dataset.hcLoaded = 'true';
        });
      };

      const openLightbox = (index = 0) => {
        if (!lightbox || !lightboxSlider || !lightboxSlides.length) return;

        hydrateLightboxImages(index);
        lightboxPreviousFocus = document.activeElement;
        lightboxPreviousBodyOverflow = document.body.style.overflow;
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';

        window.requestAnimationFrame(() => {
          setLightboxIndex(index, 'auto');
          lightboxSlider.focus({ preventScroll: true });
        });
      };

      const closeLightbox = () => {
        if (!lightbox || lightbox.hidden) return;

        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = lightboxPreviousBodyOverflow;

        if (lightboxPreviousFocus instanceof HTMLElement) {
          lightboxPreviousFocus.focus({ preventScroll: true });
        }
      };

      mainSliderNode?.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        mainNavigationTargetIndex = null;
        mainPointerStart = { x: event.clientX, y: event.clientY };
        mainPointerDragged = false;
      }, { passive: true });

      mainSliderNode?.addEventListener('pointermove', (event) => {
        if (!mainPointerStart) return;

        const dragDistance = Math.hypot(
          event.clientX - mainPointerStart.x,
          event.clientY - mainPointerStart.y
        );
        if (dragDistance > 8) {
          mainPointerDragged = true;
          mainSuppressClickUntil = Date.now() + 450;
        }
      }, { passive: true });

      mainSliderNode?.addEventListener('pointerup', () => {
        if (mainPointerDragged) {
          mainSuppressClickUntil = Date.now() + 450;
        }
        mainPointerStart = null;
        mainPointerDragged = false;
      }, { passive: true });

      mainSliderNode?.addEventListener('pointercancel', () => {
        mainPointerStart = null;
        mainPointerDragged = false;
        mainSuppressClickUntil = Date.now() + 450;
      }, { passive: true });

      mainSliderNode?.addEventListener('click', (event) => {
        if (Date.now() < mainSuppressClickUntil || mainPointerDragged) {
          event.preventDefault();
          mainPointerDragged = false;
          return;
        }

        openLightbox(getCurrentGalleryIndex());
      });

      lightboxCloseControls.forEach((control) => {
        control.addEventListener('click', closeLightbox);
      });

      lightboxPrev?.addEventListener('click', () => setLightboxIndex(lightboxIndex - 1));
      lightboxNext?.addEventListener('click', () => setLightboxIndex(lightboxIndex + 1));

      lightboxThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          setLightboxIndex(Number(thumb.dataset.hcLightboxThumb) || 0);
        });
      });

      lightboxSlider?.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        lightboxPointerStart = {
          x: event.clientX,
          y: event.clientY,
          index: lightboxIndex
        };
        lightboxPointerIsDown = true;
        window.clearTimeout(lightboxSnapTimer);
        lightboxSlider.classList.add('is-dragging');
      }, { passive: true });

      const finishLightboxSwipe = (event) => {
        if (!lightboxPointerStart) return;

        const deltaX = event.clientX - lightboxPointerStart.x;
        const deltaY = event.clientY - lightboxPointerStart.y;
        const isHorizontalSwipe = Math.abs(deltaX) > 44 && Math.abs(deltaX) > Math.abs(deltaY) * 1.15;

        lightboxPointerIsDown = false;
        lightboxSlider?.classList.remove('is-dragging');

        if (isHorizontalSwipe) {
          setLightboxIndex(lightboxPointerStart.index + (deltaX < 0 ? 1 : -1));
        } else {
          setLightboxIndex(lightboxIndex);
        }

        lightboxPointerStart = null;
      };

      lightboxSlider?.addEventListener('pointerup', finishLightboxSwipe);
      lightboxSlider?.addEventListener('pointercancel', () => {
        lightboxPointerIsDown = false;
        lightboxPointerStart = null;
        lightboxSlider.classList.remove('is-dragging');
      });

      lightboxSlider?.addEventListener('scroll', () => {
        if (lightboxScrollFrame) return;

        lightboxScrollFrame = window.requestAnimationFrame(() => {
          lightboxScrollFrame = null;
          const slideWidth = lightboxSlider.offsetWidth || 1;
          const index = clampLightboxIndex(Math.round(lightboxSlider.scrollLeft / slideWidth));
          updateLightboxControls(index);

          if (lightboxPointerIsDown) return;

          window.clearTimeout(lightboxSnapTimer);
          lightboxSnapTimer = window.setTimeout(() => {
            lightboxSlider.scrollTo({
              left: index * slideWidth,
              behavior: 'smooth'
            });
          }, 120);
        });
      }, { passive: true });

      lightbox?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeLightbox();
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setLightboxIndex(lightboxIndex - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          setLightboxIndex(lightboxIndex + 1);
        }
      });

      window.addEventListener('resize', () => {
        if (!lightbox || lightbox.hidden) return;
        setLightboxIndex(lightboxIndex, 'auto');
      });

};

